import React from "react";
import { NavLink } from "react-router-dom";

import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Badge,
} from "@material-ui/core";
import {
  Notifications as NotificationsIcon,
  ListAlt as ListIcon,
} from "@material-ui/icons/";
import { connect } from "react-redux";
import "./header.css";
import Drawer from "./Drawer";

import { logout } from "../../actions/authActions";

const Header = (props) => {
  const { isAuthenticated } = props.auth;

  const authLink = (
    <>
      <div style={{ marginLeft: "auto" }}>
        <Drawer {...props} />
      </div>
    </>
  );

  if (!isAuthenticated) {
    return <></>;
  }

  return (
    <div>
      <AppBar
        position="static"
        style={
          props.auth.seller.open
            ? { background: "dodgerblue" }
            : { background: "grey" }
        }
      >
        <Toolbar>
          <Typography variant="h6" noWrap style={{ margin: "0 auto 0 0" }}>
            {props.auth.seller.name}
          </Typography>
          <NavLink
            to={`/dashboard/${props.auth.seller._id}`}
            exact={true}
            className="navbar"
            activeStyle={{ color: "gold",background:'none' }}
            style={{ margin: "auto" }}
          >
            <IconButton color="inherit">
              <ListIcon />
            </IconButton>
          </NavLink>

          <NavLink
            to={`/notifications/${props.auth.seller.name}/${props.auth.seller._id}`}
            exact={true}
            className="navbar"
            activeStyle={{ color: "gold" }}
            style={{ margin: "auto",background:'none' }}
          >
            <IconButton color="inherit">
              <Badge
                badgeContent={
                  props.notifications ? props.auth.notifications.length : 0
                }
                color="secondary"
              >
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </NavLink>
          {props.auth.isAuthenticated ? authLink : ""}
        </Toolbar>
      </AppBar>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(Header);
